export const APP_CONFIG_DEFAULTS = {
    supportsChatInput: true,
    supportsVideoInput: false,
    isPreConnectBufferEnabled: true,
};
